<template>
  <section class="cooperaModifyDiv" id="cooperaModifyDiv">
    <section class="viewTitle">
      <viewTitle
        :title="
          `业务管理 / 合作单位管理 / 单位管理 / ${
            type === 'add' ? '新建单位' : '编辑单位信息'
          }`
        "
        :showReturn="true"
      />
    </section>

    <section class="p16">
      <el-form label-width="130px" style="width: 550px;">
        <el-form-item
          label="单位类别"
          :rules="[{ required: true, message: '' }]"
        >
          <el-select
            v-model="params.unit"
            placeholder="请选择单位类别"
            @change="changeUnit"
            style="width: 100%;"
          >
            <el-option
              v-for="item in unitOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="单位全称"
          :rules="[{ required: true, message: '' }]"
        >
          <el-input
            v-model="params.unitName"
            placeholder="请输入营业执照上的单位全称"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位简称">
          <el-input
            v-model="params.unitSimpleName"
            placeholder="请输入10个字符以内的简称"
          ></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码">
          <el-input
            v-model="params.creditCode"
            placeholder="请输入营业执照上的统一社会信用代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="营业执照扫描件">
          <el-upload
            class="avatar-uploader"
            ref="upload"
            :http-request="uploadFile"
            action=""
            :auto-upload="true"
            :show-file-list="false"
            :multiple="false"
            :file-list="fileList"
            accept="image/jpg, image/jpeg, image/png"
          >
            <el-image
              v-if="params.scanPhotoUrl"
              style="width: 80px; height: 80px"
              :src="params.scanPhotoUrl"
              fit="cover"
            ></el-image>
            <i
              v-if="params.scanPhotoUrl"
              class="el-icon-circle-close avatar"
              @click.stop
              @click="delFile"
            ></i>
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
              style="border: 1px dashed #d9d9d9;"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="单位规模">
          <el-select
            v-model="params.unitScaleValue"
            placeholder="请选择单位规模"
            style="width: 100%;"
            clearable
          >
            <el-option
              v-for="(item, index) in unitScaleOptions"
              :key="index"
              :label="item"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营范围">
          <el-input
            type="textarea"
            v-model="params.scope"
            placeholder="请输入经营范围（限500个字符）"
            rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="主要联系人"
          :rules="[{ required: true, message: '' }]"
        >
          <el-input
            v-model="params.link"
            placeholder="请输入主要联系人"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号码"
          :rules="[{ required: true, message: '' }]"
        >
          <el-input
            v-model="params.phone"
            placeholder="请输入手机号码（作为登录账号）"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="可用业务"
          :rules="[{ required: true, message: '' }]"
        >
          <el-checkbox-group v-model="params.serviceInclude">
            <div v-for="(item, index) in serviceOptions" :key="item.id">
              <el-checkbox
                :label="item.id"
                style="width: 25%;"
                @change="changeCheckbox(item.id)"
              >
                {{ item.name }}
              </el-checkbox>
              <el-select
                v-model="params.include[serviceOptions[index].id]"
                multiple
                placeholder="请选择可用业务"
                style="width: 73%;vertical-align: top;margin: 5px 0px 0px 8px;"
                @change="changeInclude(serviceOptions[index].id)"
              >
                <el-option
                  v-for="items in item.business"
                  :key="items.id"
                  :label="items.name"
                  :value="items.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="启用企业微信"
          :rules="[{ required: true, message: '' }]"
        >
          <el-radio-group v-model="params.weixin" @change="changeWeixinRadio">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
          <div v-if="Number(params.weixin) === 1">
            <div v-for="(itemList, index) in listSuperAdmin" :key="index">
              <span
                class="adminItem"
                v-for="(item, indexItem) in itemList"
                :key="indexItem"
              >
                <User
                  :item="item"
                  :key="index + indexItem"
                  :type="index"
                  @removeTag="removeTag(index, item.id)"
                />
              </span>
            </div>
            <div>
              <span
                type="text"
                @click="selectSuperAdmin"
                style="color: #409EFF;"
              >
                选择启用范围
              </span>
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">
                  如成员属于多个单位，则只取最先创建且有效的单位。
                </div>
                <i class="el-icon-question" style="color: #409EFF"></i>
              </el-tooltip>
            </div>
          </div>
          <!-- <el-select
            v-model="params.weixinIds"
            multiple
            placeholder="请选择成员或部门"
            style="width: 100%;"
            :disabled="Number(params.weixin) === 0"
          >
            <el-option
              v-for="items in unitScaleOptions"
              :key="items"
              :label="items"
              :value="items"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="params.remark"
            placeholder="请输入备注（限500个字符）"
            rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="margin: 30px 0px 0px 0px;" v-if="type === 'add'">
        <el-button type="primary" @click="save('add')" size="small">
          确认创建
        </el-button>
        <!-- <el-button
          @click="
            $router.push({
              path: '/rhqy/service/coopera/List'
            })
          "
          >返回</el-button
        > -->
      </div>
      <div style="margin: 30px 0px 0px 0px;" v-if="type === 'edit'">
        <el-button type="primary" @click="save('edit')" size="small">
          保 存
        </el-button>
        <!-- <el-button
          @click="
            $router.push({
              path: '/rhqy/service/coopera/List/detail'
            })
          "
          >返回</el-button
        > -->
      </div>
    </section>
    <Dept
      :model="deptListObj.model"
      :title="deptListObj.title"
      :visible="deptListObj.visible"
      :selected="deptListObj.pluginResult.select"
      @confirm="deptListObjConfirm"
      @updateVisible="deptListObjUpdateVisible"
    />

    <el-dialog
      :visible.sync="dialogParams.show"
      width="30%"
      :show-close="dialogParams.title === '确认提醒'"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogParams.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.show = false" size="small">
          <span v-if="dialogParams.title === '确认提醒'">取 消</span>
          <span v-else>我知道了</span>
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="checkConflict"
          v-if="dialogParams.title === '确认提醒'"
          >确定无误</el-button
        >
      </span>
    </el-dialog>

    <!-- 人员选择器冲突弹窗 -->
    <el-dialog title="提示" :visible.sync="conflict.show" width="30%">
      <div>
        <div v-html="conflict.conflictContent"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="conflict.show = false" size="small">
          取 消
        </el-button>
        <el-button type="primary" @click="confirmSave" size="small">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import viewTitle from "@/components/viewTitle";
import Dept from "@/components/qyDept/";
import User from "@/components/qyDept/user";
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";

export default {
  data() {
    return {
      value: "",
      params: {
        id: 0,
        unit: "", // 单位类别id
        unitId: "", // 用于当前单位类别失效时使用（编辑）
        unitName: "", // 单位全称
        unitSimpleName: "", // 单位简称
        creditCode: "", // 统一社会信用代码
        scanPhotoUrl: "", // 营业执照扫描件
        scanPhotoObj: {}, // 营业执照扫描件对象
        unitScaleValue: "", // 单位规模
        scope: "", // 经营范围
        link: "", // 主要联系人
        phone: "", // 手机号码
        remark: "", // 备注
        serviceInclude: [], // 业务复选框
        include: {}, // 业务下拉选择
        weixin: "0", // 是否启用企业微信
        weixinIds: [] // 企业微信下拉选择
      },
      conflict: {
        show: false,
        conflictContent: ""
      },
      fileList: [],
      scanSrc: "",
      serviceOptions: [],
      unitOption: [],
      unitScaleOptions: [
        "1-30人",
        "31-50人",
        "51-100人",
        "101-200人",
        "201-500人",
        "501-1000人",
        "1001人及以上"
      ],
      dialogParams: {
        tag: "",
        show: false,
        title: "",
        content: ""
      },
      rowDataObj: {},
      listSuperAdmin: { org: [], group: [], user: [] }, // 人员选择器
      deptListObj: {
        title: "选择发送范围",
        model: "both",
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false
      },
      orgUrl: ""
    };
  },

  components: {
    viewTitle,
    Dept,
    User
  },

  mixins: [mixinOrgUrl],

  computed: {
    type() {
      return this.$route.query.type;
    },
    id() {
      return this.$route.query.id;
    }
  },

  async mounted() {
    if (this.type === "edit") {
      this.orgUrl = await this.mixinOrgUrlSet();
      this.params.id = this.id;
      this.getDetail();
    }
    this.getUnitList();
    this.getServiceList();
  },

  async activated() {},

  created() {},

  methods: {
    // 人员选择器
    deptListObjConfirm(obj) {
      for (let key in obj) {
        this.deptListObj.pluginResult.select[key] = obj[key];
      }
      this.setSuperAdminUser();
    },

    deptListObjUpdateVisible(val) {
      this.deptListObj.visible = val;
    },

    selectSuperAdmin() {
      this.deptListObj.visible = true;
    },

    setSuperAdminUser() {
      this.listSuperAdmin = this.deptListObj.pluginResult.select;
    },

    removeTag(key, reItem) {
      let delIndex = 0;
      this.deptListObj.pluginResult.select[key].forEach((item, index) => {
        if (reItem == item.id) {
          delIndex = index;
        }
      });
      this.deptListObj.pluginResult.select[key].splice(delIndex, 1);
    },

    // 选择单位类别
    changeUnit(val) {
      this.params.serviceInclude = [];
      for (let key in this.params.include) {
        this.params.include[key] = [];
      }
      let obj = this.unitOption;
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].id === val) {
          for (let j = 0; j < obj[i].business_ids.length; j++) {
            this.params.serviceInclude.push(obj[i].business_ids[j].com_id);
            this.params.include[obj[i].business_ids[j].com_id] =
              obj[i].business_ids[j].business_ids;
          }
        }
      }
    },

    // 开始上传
    uploadFile(req) {
      console.log(req);
      this.scanSrc = window.URL.createObjectURL(req.file);
      const data = new FormData();
      data.append("file", req.file);
      if (!/(\.jpeg)|(\.jpg)|(\.png)/.test(req.file.name.toLowerCase())) {
        this.$common.pcToastFail("只能上传jpeg、jpg、png文件");
        return false;
      }
      if (req.filesize > 1024 * 1000 * 20) {
        this.$common.pcToastFail("文件大小不能超过20M");
        return false;
      }
      this.$common
        .http({
          url: "/api/media/upload",
          file: data
        })
        .then(res => {
          this.params.scanPhotoUrl = res.data.data.real_path;
          this.params.scanPhotoObj = res.data.data;
          this.params.scanPhotoObj.id = 0;
          this.$common.pcToastSuccess("上传成功");
        });
    },

    // 删除照片
    delFile() {
      this.params.scanPhotoUrl = "";
      this.params.scanPhotoObj = {};
    },

    // 获取单位类别列表
    async getUnitList() {
      await this.$common
        .http({
          url: "/api/queue/admin/query_unit_class",
          data: {
            state: 1,
            keyword: "",
            class_id: "",
            page_size: ""
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.unitOption = res.data.data.data;
        });
    },

    // 获取业务列表
    async getServiceList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_company",
        data: {}
      });
      let obj = dataObj.data.data;
      this.serviceOptions = obj;
    },

    // 选择复选框
    changeCheckbox(id) {
      // 清空下拉选择内容
      this.params.include[id] = [];
    },

    // 选择可用业务
    changeInclude() {
      this.params.serviceInclude = [];
      for (let key in this.params.include) {
        if (this.params.include[key].length > 0) {
          this.params.serviceInclude.push(key);
        }
      }
    },

    // 选择启用企业微信
    changeWeixinRadio() {
      // 清空人员选择器
      this.deptListObj.pluginResult = {
        select: { org: [], group: [], user: [] }
      };
      this.listSuperAdmin = { org: [], group: [], user: [] };
    },

    // 获取单位详情
    async getDetail() {
      await this.$common
        .http({
          url: "/api/queue/admin/query_unit_detail",
          data: {
            id: this.id
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.rowDataObj = res.data.data;
          this.params.id = this.id;
          // 判断当前类别是否存在
          this.unitOption.forEach(item => {
            if (item.id === this.rowDataObj.class_id) {
              this.params.unit = this.rowDataObj.class_id; // 类别id
            }
          });
          if (this.params.unit === "") {
            this.params.unit = this.rowDataObj.class_name;
            this.params.unitId = this.rowDataObj.class_id;
          }
          this.params.unitName = this.rowDataObj.full_name; // 单位全称
          this.params.unitSimpleName = this.rowDataObj.short_name; // 单位简称
          this.params.creditCode = this.rowDataObj.unified_social_credit_code; // 社会信用代码
          this.params.scanPhotoObj = this.rowDataObj.file;
          this.params.scanPhotoUrl =
            this.rowDataObj.file === null ? "" : this.rowDataObj.file.real_path; // 营业执照扫描件对象
          this.params.unitScaleValue =
            this.rowDataObj.unit_size === 0
              ? ""
              : this.rowDataObj.unit_size - 1; // 单位规模
          this.params.scope = this.rowDataObj.business_scope; // 经营范围
          this.params.link = this.rowDataObj.contact; // 联系人
          this.params.phone = this.rowDataObj.phone; //手机号码
          this.params.remark = this.rowDataObj.note; //备注
          this.params.weixin = String(this.rowDataObj.is_open_wx_work); // 是否启用企业微信
          for (let i = 0; i < this.rowDataObj.business.length; i++) {
            this.params.serviceInclude.push(this.rowDataObj.business[i].com_id);
            this.params.include[
              this.rowDataObj.business[i].com_id
            ] = this.rowDataObj.business[i].business_ids;
          } // 可用业务
          // 人员选择器
          this.$common
            .http({
              url: this.orgUrl.getInitData,
              data: {
                depts:
                  this.rowDataObj.dept_list !== ""
                    ? JSON.parse(this.rowDataObj.dept_list)
                    : "",
                users:
                  this.rowDataObj.user_list !== ""
                    ? JSON.parse(this.rowDataObj.user_list)
                    : ""
              }
            })
            .then(res1 => {
              console.log(res1);
              let obj1 = res1.data.data;
              this.listSuperAdmin = {
                org: obj1.depts,
                group: obj1.tags,
                user: obj1.users
              };
              this.deptListObj.pluginResult.select = {
                org: obj1.depts,
                group: obj1.tags,
                user: obj1.users
              };
            });
        });
    },

    // 保存
    save(tag) {
      this.dialogParams.type = tag;
      this.dialogParams.title = "确认提醒";
      // 人员选择器
      let user_list = [];
      this.listSuperAdmin.user.forEach(item => {
        user_list.push(item.id);
      });
      let dept_list = [];
      this.listSuperAdmin.org.forEach(item => {
        dept_list.push(item.id);
      });
      // let group_list = [];
      // this.listSuperAdmin.group.forEach(item => {
      //   group_list.push(item.id);
      // });
      if (this.params.unit === "") {
        this.$common.pcToastFail("请选择单位类别");
        return false;
      }
      if (this.params.unitName.trim() === "") {
        this.$common.pcToastFail("请输入单位全称");
        return false;
      }
      if (this.params.unitSimpleName.trim().length > 10) {
        this.$common.pcToastFail("单位简称不能超过10个字");
        return false;
      }
      if (this.params.scope.trim().length > 500) {
        this.$common.pcToastFail("经营范围不能超过500个字");
        return false;
      }
      if (this.params.link.trim() === "") {
        this.$common.pcToastFail("请输入主要联系人");
        return false;
      }
      if (this.params.phone.trim() === "") {
        this.$common.pcToastFail("请输入手机号码");
        return false;
      }
      if (
        !/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/.test(
          this.params.phone.trim()
        )
      ) {
        this.$common.pcToastFail("手机号码的格式不正确");
        return false;
      }
      if (this.params.serviceInclude.length === 0) {
        this.$common.pcToastFail("请选择可用业务");
        return false;
      }
      let num = 0;
      for (let i = 0; i < this.params.serviceInclude.length; i++) {
        if (this.params.include[this.params.serviceInclude[i]].length === 0) {
          num = num + 1;
        }
      }
      if (num === this.params.serviceInclude.length) {
        this.$common.pcToastFail("请至少选择一个可用业务");
        return false;
      }
      if (this.params.weixin.trim() === "") {
        this.$common.pcToastFail("请选择是否启用企业微信");
        return false;
      }
      if (Number(this.params.weixin) === 1) {
        // if (user_list.length === 0 && dept_list.length === 0 && group_list.length === 0) {
        if (user_list.length === 0 && dept_list.length === 0) {
          this.$common.pcToastFail("请选择启用企业微信的范围");
          return false;
        }
      }
      if (this.params.remark.trim().length > 500) {
        this.$common.pcToastFail("备注不能超过500个字");
        return false;
      }
      if (tag === "add") {
        this.dialogParams.content =
          "确认要创建单位账户吗？确认前请先核实全部信息是否正确无误！";
      } else if (tag === "edit") {
        this.dialogParams.content =
          "确认要保存单位账户吗？确认前请先核实全部信息是否正确无误！";
      }
      this.dialogParams.show = true;
    },

    // 校验人员选择器是否冲突
    checkConflict() {
      this.dialogParams.show = false;
      console.log("校验冲突");
      let user_list = [];
      this.listSuperAdmin.user.forEach(item => {
        user_list.push(item.id);
      });
      let dept_list = [];
      this.listSuperAdmin.org.forEach(item => {
        dept_list.push(item.id);
      });
      if (Number(this.params.weixin) === 0) {
        this.confirmSave();
      } else {
        this.$common
          .http({
            url: "/api/queue/admin/check_unit_scope",
            data: {
              unit_id: this.type === "add" ? 0 : this.rowDataObj.id,
              user_list: JSON.stringify(user_list),
              dept_list: JSON.stringify(dept_list)
            }
          })
          .then(res => {
            console.log(res);
            let obj1 = res.data.data;
            // 人员选择器
            this.$common
              .http({
                url: this.orgUrl.getInitData,
                data: {
                  depts: obj1.dept_list !== "" ? obj1.dept_list : "",
                  users: obj1.user_list !== "" ? obj1.user_list : "",
                  tags: ""
                }
              })
              .then(res1 => {
                console.log(res1.data.data);
                let deptObj = res1.data.data;
                let org = [];
                let user = [];
                deptObj.depts.forEach(item => {
                  org.push(item.name);
                });
                deptObj.users.forEach(item => {
                  user.push(item.name);
                });
                let orgText =
                  org.length > 0 ? `部门：${org.join("、")}<br />` : "";
                let userText =
                  user.length > 0 ? `人员：${user.join("、")}<br />` : "";
                let text = `<div style='line-height: 20px;'>
            ${orgText}${userText}
            已存在其他单位，是否继续选择？</div>`;
                if (org.length > 0 || user.length > 0) {
                  console.log(org, user);
                  this.conflict.conflictContent = text;
                  this.conflict.show = true;
                } else {
                  this.confirmSave();
                }
              });
          });
      }
    },

    // 再次确认保存
    confirmSave() {
      console.log("保存");
      this.dialogParams.show = false;
      this.conflict.show = false;

      let idsObj = {};
      for (let i = 0; i < this.params.serviceInclude.length; i++) {
        idsObj[this.params.serviceInclude[i]] = this.params.include[
          this.params.serviceInclude[i]
        ];
      }
      // 人员选择器
      let user_list = [];
      this.listSuperAdmin.user.forEach(item => {
        user_list.push(item.id);
      });
      let dept_list = [];
      this.listSuperAdmin.org.forEach(item => {
        dept_list.push(item.id);
      });
      let group_list = [];
      this.listSuperAdmin.group.forEach(item => {
        group_list.push(item.id);
      });
      console.log(JSON.stringify(this.params.scanPhotoObj) === "{}");
      let classId = ""; // 单位类别id
      if (this.params.unit === this.rowDataObj.class_name) {
        classId = this.params.unitId;
      } else {
        classId = this.params.unit;
      }
      let data = {
        id: this.params.id,
        class_id: classId,
        full_name: this.params.unitName,
        short_name: this.params.unitSimpleName,
        unified_social_credit_code: this.params.creditCode,
        file:
          JSON.stringify(this.params.scanPhotoObj) === "{}"
            ? ""
            : JSON.stringify(this.params.scanPhotoObj),
        unit_size:
          this.params.unitScaleValue === ""
            ? 0
            : this.params.unitScaleValue + 1,
        business_scope: this.params.scope,
        contact: this.params.link,
        phone: this.params.phone,
        is_open_wx_work: Number(this.params.weixin),
        user_list: JSON.stringify(user_list),
        dept_list: JSON.stringify(dept_list),
        group_list: JSON.stringify(group_list),
        business_ids: JSON.stringify(idsObj),
        note: this.params.remark
      };
      console.log(data);

      this.$common
        .http({
          url: "/api/queue/admin/save_unit",
          data: data
        })
        .then(res => {
          let obj = res.data.data;
          console.log(obj);
          // this.dialogParams.content = `已成功创建<span class='color67'>${this.params.unitName}</span>的单位账户，并随机创建了登录密码。`;
          if (this.type === "add") {
            this.$common.pcToastSuccess(
              `已成功创建“${this.params.unitName}”的单位账户，并随机创建了登录密码。`
            );
          } else if (this.type === "edit") {
            this.$common.pcToastSuccess(
              `已成功保存“${this.params.unitName}”的单位账户信息。`
            );
          }
          setTimeout(() => {
            this.$router.history.go(-1);
          }, 1500);
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.cooperaModifyDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding: 24px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  .introduce {
    color: red;
    line-height: 25px;
    margin: 0px 0px 16px;
    font-size: 14px;
  }
  // 头像
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 90px;
    line-height: 90px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 88px;
    height: 88px;
    line-height: 90px;
    text-align: center;
  }
  .avatar {
    vertical-align: top;
    margin: -7px 0px 0px -11px;
    z-index: 999;
    position: absolute;
    font-size: 18px;
    color: #60627f;
  }
  .adminItem {
    margin-right: 10px;
  }
}
.el-form-item {
  margin-bottom: 12px;
}
.el-checkbox,
.el-checkbox__input {
  white-space: normal;
  word-break: break-all;
}
</style>
<style lang="less">
#cooperaModifyDiv .el-checkbox__label {
  width: 70%;
  vertical-align: text-top;
}
</style>
